import React from 'react';
import {observer} from 'mobx-react';
import ExpensesSubnav from '../../ExpensesSubnav';

const MyExpensesContainer = observer(({scope}) => {
  return (
    <div>
      <ExpensesSubnav scope={scope} />
    </div>
  );
});

export default MyExpensesContainer;
